import React from 'react';
import { ShimmerTitle, ShimmerThumbnail } from "react-shimmer-effects";
import { BaseCard } from '../commonComponents';

const PlanningCardLoader = () => {
  return (
    <>
      <div style={{ width: '80%' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" /></div>
      <div style={{ width: '100%' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 mg-t-10 d-block" /></div>
      <div style={{ width: '60%' }}><ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 mg-t-10 d-block" /></div>
    </>
  )
}

const PlanningCardLoader2 = () => {
  return (
    <>
      <BaseCard customBaseCardStyle='pd-15 rounded-3 mg-t-20'>
        <ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 d-block" />
        <ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 mg-t-10 d-block" />
        <ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 mg-t-10 d-block" />
        <ShimmerTitle line={1} gap={0} variant="primary" className="mg-b-0 mg-t-10 d-block" />
      </BaseCard>
    </>
  )
}

const PlanningLoader = () => {
  return (
    <>
      <div className='mg-t-30'><PlanningCardLoader /></div>
      <PlanningCardLoader2 />
      <div className='mg-t-20'><PlanningCardLoader /></div>
      <PlanningCardLoader2 />
      <div className="w-100 mg-t-20"><ShimmerThumbnail height={45} className="rounded-3 mb-0" /></div>
      <div className='mg-t-20'><PlanningCardLoader /></div>
      {
        Array.from({ length: 8 }).map(_ => {
          return (
            <div className="w-100 mg-t-20"><ShimmerThumbnail height={66} className="rounded-3 mb-0" /></div>
          );
        })
      }
    </>
  );
};

export default PlanningLoader;
